import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const TE = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	useEffect(() => {
		i18n.changeLanguage(props.lang);
	}, []);

	if (form_component.te_style === 'line') {
		return (
			<div className="separator border-gray-400 my-3"></div>
		);
	} else if (form_component.te_style === 'space') {
		return (
			<div className={`te-space h-${form_component.space_height}`}></div>
		);
	} else {
		return (
			<div className={`xt_area te-${form_component.te_style}`} dangerouslySetInnerHTML={{ __html: form_component.content }} />
		);
	}
}

export default TE;